import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MetaPreviewData } from '../../../../../../../models/meta-template/preview-interfaces/meta-preview-data.interface';
import { MetaCreativeComponent } from '../../../preview-common/meta-creative/meta-creative.component';
import { MetaPreviewCopy } from '../../../preview-common/meta-preview-copy';

/**
 * Instagram Explore home ("Početna stranica odjeljka Istraži na Instagramu"):
 * the ad is one tile of the Explore grid; the other tiles are placeholders.
 */
@Component({
  selector: 'app-meta-instagram-explore',
  imports: [CommonModule, MetaCreativeComponent],
  templateUrl: './instagram-explore.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './instagram-explore.component.scss'
})
export class MetaInstagramExplorePreviewComponent {
  @Input() data!: MetaPreviewData;

  readonly avatar = MetaPreviewCopy.AVATAR;

  /** 3x4 grid; the ad takes the middle tile of the second row. */
  readonly tiles = Array.from({ length: 12 }, (_, i) => i);
  readonly adTile = 4;
}
